<template>
  <span id="update-all-shippers-section" class="margin-r-10" v-if="this.$can(this.permissions.WAREHOUSE.EDIT_SHIPPERS)">
    <el-button
      id="btn-update-all-shippers-group"
      type="success"
      size="mini"
      plain
      v-show="shipperPage.total > 0"
      @click="dialogVisible = true"
    >{{ $t('shipper.updateAllGroup') }}</el-button>
    <el-dialog
      width="30%"
      class="dialog-with-cols"
      :close-on-click-modal="false"
      :title="$t('shipper.updateGroup')"
      :visible.sync="dialogVisible"
      @open="handleOpen()"
    >
      <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
        <el-row class="shipper-group-warning">
          <el-col :span="24">
            <span v-html="$t('shipper.updateGroupWarning').replace('[numberOfShippers]', shipperPage.total)"></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="form-vertical-item">
            <el-form-item :label="$t('shipper.shipperGroup')" prop="shipperGroupId">
              <shipper-group-select
                ref="shipperGroupSelect"
                :value.sync="form.shipperGroupId"
                :includeOptionAll="false"
                :includeOptionNone="true"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div id="update-all-shippers-group-dialog-footer" class="dialog-footer form-vertical-item flex-reverse-direction" slot="footer">
        <el-button
          id="form-save-button"
          type="primary"
          size="mini"
          @click="submitForm()"
        >{{ $t('common.updateAll') }}</el-button>
        <el-button id="form-cancel-button" size="mini" @click="resetForm()">{{ $t('common.clear') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import ShipperGroupSelect from '@/components/ShipperGroup/ShipperGroupSelect';

export default {
  name: 'ShipperGroupBulkUpdate',
  components: { ShipperGroupSelect },
  computed: {
    ...mapGetters([
      'shipperPage'
    ])
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        shipperGroupId: 0
      },
      formRules: {
        shipperGroupId: [
          { required: true, message: this.$t('shipper.error.shipperGroupRequired'), trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          try {
            const response = await this.$store.dispatch('account/shipperGroupBulkUpdate', this.form.shipperGroupId);
            this.$message.success(response.message);
            this.resetForm();
            this.$store.dispatch('account/searchShippers', {});
          } finally {
            loading.close();
          }
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.shipperGroupId = 0;
      this.$refs.shipperGroupSelect.setSelectedShipperGroup(this.form.shipperGroupId);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
  .shipper-group-warning {
    margin-bottom: 20px;
  }
</style>
